import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { redHookConfig } from "./data";

export default function RedHookPage() {
  return <CityPageTemplate config={redHookConfig} />;
}